// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"IdPreferences_loadingOverlay__zR9jf","linkButton":"IdPreferences_linkButton__sTy3I"};